import fp from 'lodash/fp';
import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  EXTERNAL_CPD: {
    UPDATE: (externalCpd, cpdCategoryPoints, goals, files, nextRoute) => ({ externalCpd, cpdCategoryPoints, goals, files, nextRoute }),
    API: {
      UPDATE: apiResourceActionCreator('externalCpd')
    }
  }
})

export const apiAction = (authToken, externalCpdId, formData) => commonApiActions.authenticated.putFormData(`${API_ENDPOINT}/${externalCpdId}`, authToken, formData, action.externalCpd.api.update)

export function* updateExternalCpd({ payload }) {
  const authToken = yield select(authTokenSelector);

  const contentFormData = {
    data: {
      externalCpd: {
        ...payload.externalCpd,
        files: undefined,
        existingFiles: undefined
      },
      goals: payload.goals,
      cpdCategoryPoints: payload.cpdCategoryPoints,
      files: payload.externalCpd.existingFiles ? payload.externalCpd.existingFiles : []
    },
    file: payload.files
  };

  yield put(apiAction(authToken, payload.externalCpd.id, contentFormData));

  const externalCpdResult = yield apiActionResult(action.externalCpd.api.update);

  if (externalCpdResult.success) {
    const {
      nextRoute
    } = payload
    yield put(push({ pathname: nextRoute ? nextRoute : routes.app.professionalProfile.root }));
  }
}

const configuration = {
  name: 'update',
  action: action,
  sagas: updateExternalCpd,
  reducers: {
    request: (state, action) => fp.flow(
      fp.set('request.update.isFetching')(true),
      fp.set('error')(null)
    )(state),
    success: (state, action) => fp.flow(
      fp.set('request.update.isFetching')(false),
      fp.set('externalCpd')(action.payload.externalCpd)
    )(state),
    failed: (state, action) => fp.flow(
      fp.set('request.update.isFetching')(false),
      fp.set('request.update.error')(action.payload.error),
      fp.set('error')(action.payload.error)
    )(state)
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/external-cpd/configurations/update.js